import React from "react";

function Hartex() {
  return (
    <div className="w-full mx-auto space-y-5">
      {/* Brand Intro */}
      <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Hartex</h1>
        <p className="text-gray-700 leading-relaxed text-base">
          Founded in 1961, <strong>Hartex</strong> has been a pioneer in
          crafting high-quality bicycle tyres in India, serving both domestic
          and international markets with unmatched consistency and innovation.
          With over 60 years of expertise, Hartex has established itself as a
          trusted OEM partner to some of the world’s top bicycle brands, known
          for its precision manufacturing and commitment to excellence.
        </p>
      </div>

      {/* Product Range */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          Product Range
        </h2>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-1">
          <li>Road Tyres</li>
          <li>Mountain Tyres</li>
          <li>Gravel Tyres</li>
          <li>City Tyres</li>
        </ul>
      </div>

      {/* High-Performance Lineup */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          High-Performance Lineup
        </h2>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-1">
          <li>X-Treme</li>
          <li>X-Grit</li>
          <li>X-Press</li>
          <li>X-Cite</li>
        </ul>
        <p className="text-gray-700 text-sm leading-relaxed mt-1">
          These models are foldable, tubeless-ready, and engineered for speed,
          grip, and durability—perfect for competitive riders.
        </p>
      </div>

      {/* Manufacturing Facility */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          Manufacturing Facility
        </h2>
        <p className="text-gray-700 text-sm leading-relaxed">
          Hartex operates from a state-of-the-art facility in India. The
          facility is equipped to handle advanced tyre manufacturing processes,
          ensuring high precision and quality standards across all product
          lines.
        </p>
      </div>

      {/* Brand Message */}
      <div className="max-sm:px-4">
        <p className="text-gray-700 text-sm leading-relaxed">
          Proudly made in India and trusted worldwide, Hartex is the tyre brand
          that powers your ride forward.
        </p>
        <p className="text-gray-700 text-sm leading-relaxed mt-1">
          For more, visit{" "}
          <a
            href="https://hartex.in"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            hartex.in
          </a>{" "}
          or{" "}
          <a
            href="https://hartextyres.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            hartextyres.com
          </a>
          .
        </p>
      </div>
    </div>
  );
}

export default Hartex;
